import has from "lodash-es/has";
var LocalStorage = /** @class */ (function () {
    function LocalStorage(config) {
        this.rootKey = config.rootKey;
        this.storage = config.storage || window.localStorage;
    }
    LocalStorage.prototype.get = function (key) {
        var data = this.getData();
        return Promise.resolve(data.hasOwnProperty(key) ? data[key] : null);
    };
    LocalStorage.prototype.getAll = function () {
        return Promise.resolve(this.getData());
    };
    LocalStorage.prototype.set = function (key, value) {
        var data = this.getData();
        data[key] = value;
        try {
            this.writeToStorage(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
        return Promise.resolve();
    };
    LocalStorage.prototype.has = function (key) {
        return Promise.resolve(has(this.getData(), key));
    };
    LocalStorage.prototype.clear = function (key) {
        var data = this.getData();
        delete data[key];
        this.writeToStorage(data);
        return Promise.resolve();
    };
    LocalStorage.prototype.clearAll = function () {
        this.storage.removeItem(this.rootKey);
        return Promise.resolve();
    };
    LocalStorage.prototype.getData = function () {
        var data = this.storage.getItem(this.rootKey);
        return (data !== null ? JSON.parse(data) : {});
    };
    LocalStorage.prototype.writeToStorage = function (data) {
        try {
            this.storage.setItem(this.rootKey, JSON.stringify(data));
        }
        catch (error) {
            throw Error("LocalStorage quota exceeded");
        }
    };
    return LocalStorage;
}());
export default LocalStorage;
//# sourceMappingURL=LocalStorage.js.map